import { applyElevatedCornerRadius } from "../utilities/border";
import { applyElevation, ElevationMultiplier } from "../utilities/elevation";
import { backgroundColor } from "../utilities/design-system";
import { highContrastBorder } from "../utilities/high-contrast";
const styles = {
    card: Object.assign(Object.assign(Object.assign(Object.assign({ width: "100%", height: "100%", background: backgroundColor }, applyElevatedCornerRadius()), applyElevation(ElevationMultiplier.e4)), { transition: "all 0.2s ease-in-out" }), highContrastBorder),
};
export default styles;
